import React, { FC, ReactElement, useContext } from 'react';
import { Header as GrommetHeader, ResponsiveContext } from 'grommet';
import { MobileNavMenu, NavMenu } from '@/components/layout/NavMenu';
import { Logo } from '@/components/layout/Logo';

export const Header: FC = (): ReactElement => {
  const size = useContext(ResponsiveContext);
  return (
    <GrommetHeader style={{ zIndex: 1 }}>
      <Logo />
      {size === `small` ? <MobileNavMenu /> : <NavMenu />}
    </GrommetHeader>
  );
};
